import { Immutable } from "immer";
import React from "react";
import { setFocusedStore } from "tsi-common-react/src/apps/retail/reducers";
import {
    filteredStoreSelector,
    focusedStoreIDSelector,
} from "tsi-common-react/src/apps/retail/selectors";
import { RetailStore } from "tsi-common-react/src/models/location";
import { preferredLocationSelector } from "tsi-common-react/src/store/common/selectors";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { formatPhoneNumber } from "tsi-common-react/src/utils/format";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { RetailLocatorBlock } from "./RetailLocatorContent";

import styles from "./index.module.scss";

export const RetailLocator = (): React.ReactNode => {
    const location = useAppSelector(preferredLocationSelector);
    const stores = useAppSelector(filteredStoreSelector);
    const focusedStoreID = useAppSelector(focusedStoreIDSelector);
    const dispatch = useAppDispatch();

    const onBeforeInfoWindowOpen = (
        info: google.maps.InfoWindow,
        store: Immutable<RetailStore>,
    ) => {
        dispatch(setFocusedStore({ externalID: store.external_id }));
        // TODO(i18n): The InfoWindow content displays store data but the structure is hardcoded. While store.name, store.address, etc. are data values that shouldn't be translated, the overall formatting assumes English conventions. Consider if formatting needs localization (e.g., address order, phone number format).
        const content = `
            <div><div class="${styles.locName}">${store.name}</div>
            <div>${store.address}</div>
            <div>${store.address2}</div>
            <div>${store.city}, ${store.state} ${store.postal}</div>
            <div>${store.phone ? formatPhoneNumber(store.phone) : ""}</div>
        `;
        info.setContent(content);
    };

    const onInfoWindowClose = () => {
        dispatch(setFocusedStore({ externalID: null }));
        const document = getDocument();
        const locationsList = document?.querySelector("div.locations");
        if (locationsList) {
            locationsList.scrollTop = 0;
        }
    };

    return (
        <RetailLocatorBlock
            location={location}
            stores={stores}
            focusedStoreID={focusedStoreID}
            onBeforeInfoWindowOpen={onBeforeInfoWindowOpen}
            onInfoWindowClose={onInfoWindowClose}
        />
    );
};
